<template>
  <td>
    <div class="td-box">  
      <span class="td-text ellipsis" data-original-title="">
        <slot></slot>
      </span>
    </div>
  </td>
</template>

<script>
export default {
  props:['prop', 'displayName', 'name', 'width']
}
</script>

<style>

</style>